import './Text.css';



export function TooComfortably() {
  return (
    <div class="body">



<div class="row">

  <div class="column">
      <h2>TOO COMFORTABLY, 2026</h2>
            <h4>
              Jewel Case Booklet Insert and Backing,
      2 Original Songs,
      Urban photography collection with Ria Haji.
      <br/><br/>
      Informal Complaint &#40; Recorded Meeting &#41;
      <br/><br/>Too Comfortably &#40; Song &#41;
      <br/><br/>The Friend of a White Man &#40; Song &#41;
      <br/><br/>Yamaneika Saunders &#40; Podcast Clip Recording &#41;
      <br/><br/>Too Comforatbly* &#40; Open Mic Recording &#41;
      </h4>
  </div>
{/*
  <div class="column">

      White supremacy 
      is running from 
      its own fart.
      Technological advancement and increasingly accessible information is blowing the industrial gasses, corpse methane, and destabilized descendants of the global south above the equator. 

      As American grocery items solidify, rather than rot; cities implement Israeli-Owned dispensaries, faster than bus-lanes; and political bumper stickers clothe American nukes; Americans scramble to find noise-canceling headphones that drown out their 
      destruction, and their demise.

      During the 2026 Minneapolis ICE Surge, Amar watched their White, private, art college struggle to protect and care about the marginalized students, it predatorily seeks out. 

      Amar realized that some of Them arenít intentionally malicious. Some truly donít know how to nurture community. 

      Because of the comfortable lives theyíve lived, within the hegemony, they only know how to steal, build borders, and consume others.

      If we let them remain evasive of responsibility, we continue to pay for their weaponized incompetence.
      They Living... 
      Too Comfortably is compilation of Amarís undergraduate research on systematic racism in academia, and predominantly white institutions. 

      Inspired first by Dr. Beverly Tatumís Why Are All the Black Kids Sitting Together in the Cafeteria? (2003), Amar acknowledges that when education, attitudes, music, food, and clothes, were less White, more borders were built around it. The more Whiteness hated it, and yet were hungry for it, at the same time.

      Amar acknowledged that when it comes to taking care of community, the closer you are to Whiteness, the harder it was to be helpful. And that behavior is responsible for many lost lives.

      The only remedy for this disease is to urn the hands of a clock back manually.

  </div>

<div class="column">

ìKeep It Simple, Stupid.î
Amar asked a retired middle grade teacher in Walgreens, ìIím working teens for the first time, do you have any advice?î She laughed and said this.

Inspired by Abbie Gonzalezís accessibility font OpenDyslexic, and Minnesota designer, Dr. Terresa Mosesí graphical, protest font Stop Killing Black People, Amar planned to design a font that was moral, and resistant to the cycle of slop that White hegemony creates. 

SimpleStupid is the concluding font (found on the mix tape cover). 

SimpleStupid is a scrappy, 
hand-inked, 100+ character-set, 
donation-based font.

SimpleStupid answers the biggest design concern in contemporary visual communications: ìHow do we compete for attention?î and, ìDo I want to be complicit in the contemporary 
transatlantic slave trade?î
White exhaustion
During the development, Amarís White, 60-year old professor asked repeatedly, ìWhy?î at every step of the process. Unlike constructive critique that strengthens the design, the trained ear can hear how the work was questioned in a dismissive and argumentative manner.

Amarís explanations were interrupted, and met with glossed over eyes. When the font was on screen, bouncing to music, suddenly the font was well received, at a surface level. 

When the concept of breaking past boundaries, respecting brown artists, and caring about community is verbalized in terms of racial theory, White people get lost. The said that he wouldíve preferred if I used AI.
Thesis
Like how revolutions come to be, Too Comfortably, its research, and it following works were not a choice, or a ëfuní design project my white peers got to experience without much thought. 

Too Comfortably is a reaction to abuse. Not abuse, itself. A mirror to Whitey that still believes in going to the moon. 

A wooden Trojan horse wearing chains of gold mined by slaves. A home-made leather jacket
they try to rip off you, to see if itís their size. A septum ring, pierced into teenage flesh. 

A romantic amplification of justification. A warning. A cry of starvation. The sound of cutlery clinking on empty plates. 
A militia beat.

Too Comfortably is hard to understand, if youíve spent too much time living too comfortably.

       </div>
             */}
      </div>



<div class="row">

<div class="column">
        <img src="TooComfrotablyAlbumCover2.jpg"></img>

</div>
<div class="column">
          <img src="TooComfrotablyAlbumCover.jpg"></img>
</div>
            


<div class="column">
        <video autoplay controls loop >
            <source src="InformalComplaint.mp4" type="video/mp4"/>
          </video>  
      <br/><h4>Informal Complaint<br/>13m 8s</h4>
</div>
      
<div class="column">
        <video autoplay controls loop >
            <source  src="TheFriend.mp4" type="video/mp4"/>
          </video>
           <br/><h4><a href="" target="0">The Friend of a White Man is an Enemy To Me</a>
<br/> Poem accompanied by <a href="https://hypnoticbrass.bandcamp.com/album/hypnotic-joints" target="0">One Hunnit (2017) Hypnotic Brass Ensemble</a>
<br/>13m 8s</h4>
</div>
            <div class="column">
        <video autoplay controls loop >
            <source  src="TooComfortably.mp4" type="video/mp4"/>
          </video>
           <br/><h4>Too Comfortably
<br/>2m 52s</h4>  
      </div>
      <div class="column">
        <a href="https://youtu.be/Lg5l_1phW4A?t=4391" target="_blank">
        <img src="YamaneikaSaunders.jpeg"></img></a>
         <br/><h4>Yamaneika Saunders
(on The Downside with Gianmarco Soresi)
<br/>4m 35s</h4>
      </div>


            <div class="column">
        <video autoplay controls loop>
            <source  src="OpenMic.mp4" type="video/mp4"/>
          </video>
           <br/><h4>Too Comfortably Slam, filmed by Ria Haji
<br/>2m 52s</h4>  
      </div>

      <div class="column">
        <img src="TooComfrotablyAlbumCover33.jpg"></img>
       <br/><h4>Ria Haji 2026<br/>7 digital photos</h4>
      </div>

      <div class="column">
        <img width="630px" src="RiaBio.png"></img>
      </div>

      <div class="column"><img src="RiaBio_Page.jpg"></img>
       </div>

      <div class="column"><img src="RiaBio_Page2.jpg"></img>
      </div>
      
</div>
</div>




  );
}
